import React, {useEffect, useState} from 'react';
import {Box, Typography, Grid, Card, CardContent, Button, Dialog, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
import useStyles from "../../../assets/styles/AssessmentPageStyles";
import Icon1 from "../../../assets/images/DQProImages/Graphic14.png"
import Icon2 from "../../../assets/images/DQProImages/Graphic15.png"
import Icon3 from "../../../assets/images/DQProImages/Graphic17.png"
import Icon4 from "../../../assets/images/DQProImages/Graphic18.png"
import CheckIcon from '@material-ui/icons/Check';
import {useHistory} from "react-router-dom";
import {
    getInsiderAssessmentDescriptionService,
    getInsiderPackageService,
    getInsiderUserGroupsService
} from "../../../services/assessments.service";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

const DQProAssessments = () => {
    const classes = useStyles();
    const history=useHistory();
    const [loading, setLoading] = useState(false);
    const [selectedAssessment, setSelectedAssessment] = React.useState(null);
    const [selectedIndicators, setSelectedIndicators] = React.useState([]);
    const [totalDuration, setTotalDuration] = React.useState(0);
    const [assessments,setAssessments] = useState([]);

    const Icons = [Icon1, Icon2, Icon3, Icon4];
    const mapUserGroupsToCard = (userGroup, idx) => ({
        icon: Icons[idx % Icons.length],
        title: userGroup.title,
        subtitle: userGroup.sub_title ? `(${userGroup.sub_title})` : '',
        description: userGroup.description,
        code: userGroup.code,
        packages: []
    });

    useEffect(() => {
        const fetchInsiderModules = async () => {
            try {
                const response = await getInsiderUserGroupsService();
                if (response.data.userGroups) {
                    const cards = response.data.userGroups.map(mapUserGroupsToCard);
                    setAssessments(cards);
                }
            } catch (error) {
                console.error('Error fetching assessments:', error);
            }
        };
        fetchInsiderModules().then(r => console.log(r));
    }, []);

    const normaliseTree = (tree) =>
        Object.entries(tree).map(([pkgName, pkgObj]) => {
            const { description: pkgDesc, ...modulesObj } = pkgObj;
            return {
                title: { name: pkgName, desc: pkgDesc },
                modules: Object.entries(modulesObj).map(([modName, modObj]) => {
                    const { description: modDesc, ...indicatorsObj } = modObj;
                    return {
                        title: { name: modName, desc: modDesc },
                        indicators: Object.entries(indicatorsObj).map(([indName, indObj]) => ({
                            title     : { name: indName, desc: indObj.description },
                            questions : indObj.no_of_questions,
                            duration  : indObj.duration,
                            indicator_code: indObj.indicator_code,
                            dqco_no: indObj.dqco_no
                        }))
                    };
                })
            };
        });


    const handleCardClick = async (assessment) => {
        try {
            const { data } = await getInsiderPackageService(assessment.code);
            const packages  = normaliseTree(data);
            setSelectedAssessment({ ...assessment, packages });
            setSelectedIndicators([]);
            setTotalDuration(0);
        } catch (err) {
            console.error(err);
            setSelectedAssessment({ ...assessment, packages: [] });
        }
    };

    const handleIndicatorSelect = (indicator, packageIndex, moduleIndex, indicatorIndex) => {
        const indicatorKey = `${packageIndex}-${moduleIndex}-${indicatorIndex}`;

        if (selectedIndicators.includes(indicatorKey)) {
            setSelectedIndicators(selectedIndicators.filter(item => item !== indicatorKey));
            setTotalDuration(totalDuration - indicator.duration);
        } else {
            setSelectedIndicators([...selectedIndicators, indicatorKey]);
            setTotalDuration(totalDuration + indicator.duration);
        }
    };

    return (
        <>
            <LoaderWithBackDrop loading={loading} />
            <Box className={classes.pageContainer} style={{marginTop:'auto'}}>
             {!selectedAssessment ? (
               <>
                <Typography variant="h3" className={classes.title} sx={{ mb: 2, textAlign: 'center' }}>
                    AI Readiness Assessments Available
                </Typography>
                <Typography variant="h5" sx={{ textAlign: 'center', mb: 4 }}>
                    Select a target audience you want to build an assessment for.
                </Typography>
                <Grid container spacing={4} justifyContent="center" sx={{ mt: 4 }}>
                    {assessments.map((assessment, index) => (
                        <Grid item xs={12} sm={6} md={6} lg={3} key={index}>
                            <Card className={classes.card}>
                                <img src={assessment.icon} alt="Assessment Icon" className={classes.icon} />

                                <Typography className={classes.cardTitle}>
                                    {assessment.title}
                                </Typography>
                                    <Typography className={classes.subtitle} sx={{ mb: 1, minHeight: '24px' }}>
                                        {assessment.subtitle}
                                    </Typography>
                                    <Typography className={classes.description}>
                                        {assessment.description}
                                    </Typography>
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        onClick={() => handleCardClick(assessment)}
                                    >
                                        Select
                                    </Button>
                                </Card>
                            </Grid>
                        ))}
                </Grid>
               </>
                ) : (
                 <Box sx={{ mt: {xs:'75px', lg:4 }}}>
                     <Typography variant="h3" className={classes.title} sx={{ mb: 2, textAlign: 'center' }}>
                         {selectedAssessment.title} Assessment
                     </Typography>
                     <Typography variant="h5" sx={{fontSize:{xs:'1.2rem', md:'1.5rem'}, textAlign: 'center', mb: 2,}}>
                         Select what you want to assess below. You can select up to 45 total minutes per each assessment.<br/>
                         If your selections total more than 45 minutes, you will need to break it up into 2 separate assessments.
                     </Typography>
                     <Typography sx={{ textAlign: 'center', fontSize:{md:'16px',lg:'19px'},lineHeight:'1.2', mb: 4 }}>
                         <b>Please Note:</b> Each assessment you create uses <b>one license per learner</b>. For example, if you create <b>two separate assessments</b>,<br/> each one will count as <b>a separate license</b>, even if assigned to the same learner.
                     </Typography>

                     <Box
                         sx={{
                             position:'sticky',
                             zIndex:'1',
                             top:'30px',
                             display: 'table',
                             flexDirection: 'column',
                             justifyContent: 'center',
                             alignItems: 'center',
                             p: 2,
                             borderRadius: '15px',
                             backgroundColor: '#f5f4ed',
                             boxShadow: 3,
                             margin: '0 auto 32px auto'
                         }}
                     >
                         <Typography variant="h6" sx={{ textAlign: 'left', fontWeight:'regular' }}>
                             Based on your selections, your assessment is approximately <strong>{totalDuration}</strong> minutes long.
                         </Typography>

                         {totalDuration > 45 && (
                             <Typography color="error" sx={{ textAlign: 'center', display: 'block' }}>
                                 Consider splitting into multiple assessments
                             </Typography>
                         )}
                     </Box>

                     <TableContainer component={Paper} sx={{ border: '1px solid #e0e0e0' }}>
                         <Table>
                             <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                 <TableRow sx={{ backgroundColor: '#000000 !important' }}>
                                     <TableCell sx={{
                                         borderRight: '1px solid #ddd',
                                         fontSize: '16px',
                                         fontWeight: 'bold',
                                         textAlign: 'left',
                                         color: '#ffffff !important',
                                         width: '25%'
                                     }}>
                                         Packages
                                     </TableCell>
                                     <TableCell sx={{
                                         borderRight: '1px solid #ddd',
                                         fontSize: '16px',
                                         fontWeight: 'bold',
                                         textAlign: 'left',
                                         color: '#ffffff !important',
                                         width: '25%'
                                     }}>
                                         Modules
                                     </TableCell>
                                     <TableCell sx={{
                                         borderRight: '1px solid #ddd',
                                         fontSize: '16px',
                                         fontWeight: 'bold',
                                         textAlign: 'left',
                                         color: '#ffffff !important',
                                         width: '35%'
                                     }}>
                                         Indicators
                                     </TableCell>
                                     <TableCell sx={{
                                         borderRight: '1px solid #ddd',
                                         fontSize: '16px',
                                         fontWeight: 'bold',
                                         textAlign: 'left',
                                         color: '#ffffff !important',
                                         width: '5%'
                                     }}>
                                         # of Questions
                                     </TableCell>
                                     <TableCell sx={{
                                         borderRight: '1px solid #ddd',
                                         fontSize: '16px',
                                         fontWeight: 'bold',
                                         textAlign: 'left',
                                         color: '#ffffff !important',
                                         width: '5%'
                                     }}>
                                         Duration (min)
                                     </TableCell>
                                     <TableCell sx={{
                                         borderRight: '1px solid #ddd',
                                         fontSize: '16px',
                                         fontWeight: 'bold',
                                         textAlign: 'left',
                                         color: '#ffffff !important',
                                         width: '5%'
                                     }}>
                                         Selected
                                     </TableCell>
                                 </TableRow>
                             </TableHead>
                             <TableBody>
                                 {(selectedAssessment.packages || []).map((pkg, pkgIndex) => (
                                     pkg.modules.map((module, modIndex) => (
                                         module.indicators.map((indicator, indIndex) => {
                                             const rowKey = `${pkgIndex}-${modIndex}-${indIndex}`;
                                             const isSelected = selectedIndicators.includes(rowKey);
                                             const isFirstRowInModule = indIndex === 0;
                                             const isFirstRowInPackage = isFirstRowInModule && modIndex === 0;

                                             return (
                                                 <TableRow
                                                     key={rowKey}
                                                     onClick={() => handleIndicatorSelect(indicator, pkgIndex, modIndex, indIndex)}
                                                     sx={{
                                                         '&:hover .indicatorCell': {
                                                             backgroundColor: '#4aefa2'
                                                         },
                                                         cursor: 'pointer'
                                                     }}
                                                 >
                                                     {indIndex === 0 && modIndex === 0 && (
                                                         <TableCell
                                                             sx={{
                                                                 fontSize: '17px',
                                                                 textAlign: 'left',
                                                                 borderRight: '1px solid #ddd',
                                                                 backgroundColor: isSelected ? '#f5f5f5' : 'inherit',
                                                                 width: '25%',
                                                                 verticalAlign: 'top'
                                                             }}
                                                             rowSpan={pkg.modules.reduce((acc, mod) => acc + mod.indicators.length, 0)}
                                                         >
                                                             <Typography fontWeight="bold">{pkg.title.name}</Typography>
                                                             <Typography variant="body2">{pkg.title.desc}</Typography>
                                                         </TableCell>
                                                     )}

                                                     {indIndex === 0 && (
                                                         <TableCell
                                                             sx={{
                                                                 fontSize: '17px',
                                                                 textAlign: 'left',
                                                                 borderRight: '1px solid #ddd',
                                                                 backgroundColor: isSelected ? '#f5f5f5' : 'inherit',
                                                                 width: '25%',
                                                                 verticalAlign: 'top'
                                                             }}
                                                             rowSpan={module.indicators.length}
                                                         >
                                                             <Typography variant="body2" fontWeight="bold">{module.title.name}</Typography>
                                                             <Typography variant="body2">{module.title.desc}</Typography>
                                                         </TableCell>
                                                     )}
                                                     <TableCell
                                                         className="indicatorCell"
                                                         sx={{
                                                             fontSize: '17px',
                                                             textAlign: 'left',
                                                             borderRight: '1px solid #ddd',
                                                             backgroundColor: isSelected ? '#4aefa2' : 'inherit',
                                                             width: '35%'
                                                         }}
                                                     >
                                                         <Typography variant="body2" fontWeight="bold">
                                                             {indicator.title.name}
                                                             {indicator.dqco_no && (
                                                                 <span style={{ color: '#ED6728' }}> ({indicator.dqco_no})</span>
                                                             )}
                                                         </Typography>
                                                         <Typography variant="body2">{indicator.title.desc}</Typography>
                                                     </TableCell>
                                                     <TableCell
                                                         className="indicatorCell"
                                                         sx={{
                                                             fontSize: '17px',
                                                             textAlign: 'center',
                                                             borderRight: '1px solid #ddd',
                                                             backgroundColor: isSelected ? '#4aefa2' : 'inherit',
                                                             width: '5%'
                                                         }}
                                                     >
                                                         {indicator.questions}
                                                     </TableCell>
                                                     <TableCell
                                                         className="indicatorCell"
                                                         sx={{
                                                             fontSize: '17px',
                                                             textAlign: 'center',
                                                             borderRight: '1px solid #ddd',
                                                             backgroundColor: isSelected ? '#4aefa2' : 'inherit',
                                                             width: '5%'
                                                         }}
                                                     >
                                                         {indicator.duration}
                                                     </TableCell>
                                                     <TableCell
                                                         className="indicatorCell"
                                                         sx={{
                                                             fontSize: '17px',
                                                             textAlign: 'center',
                                                             borderRight: '1px solid #ddd',
                                                             backgroundColor: isSelected ? '#4aefa2' : 'inherit',
                                                             width: '5%'
                                                         }}
                                                     >
                                                         {isSelected ? (
                                                             <Box sx={{
                                                                 display: 'flex',
                                                                 justifyContent: 'center',
                                                                 alignItems: 'center',
                                                                 width: 24,
                                                                 height: 24,
                                                                 borderRadius: '50%',
                                                                 border: '2px solid #4aefa2',
                                                                 backgroundColor: '#4aefa2',
                                                                 margin: '0 auto'
                                                             }}>
                                                                 <CheckIcon sx={{ color: 'white', fontSize: 16 }} />
                                                             </Box>
                                                         ) : (
                                                             <Box sx={{
                                                                 display: 'flex',
                                                                 justifyContent: 'center',
                                                                 alignItems: 'center',
                                                                 width: 24,
                                                                 height: 24,
                                                                 borderRadius: '50%',
                                                                 border: '2px solid #e0e0e0',
                                                                 margin: '0 auto'
                                                             }} />
                                                         )}
                                                     </TableCell>
                                                 </TableRow>
                                             );
                                         })
                                     ))
                                 ))}
                             </TableBody>
                         </Table>
                     </TableContainer>
                     <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
                     <Button
                                 className={classes.button}
                                 variant="contained"
                                 sx={{width:{xs:'35%', md:'21%'}}}
                                 disabled={selectedIndicators.length === 0 || totalDuration > 45}
                                 onClick={async () => {
                                     const indicatorObjs = selectedIndicators.map(k => {
                                         const [pkgIdx, modIdx, indIdx] = k.split('-').map(Number);
                                         return selectedAssessment.packages[pkgIdx]
                                             .modules[modIdx].indicators[indIdx];
                                     });

                                     const indicators_descriptions = indicatorObjs.map(i => i.title.desc);

                                     // let response = null;
                                     // try {
                                     //     setLoading(true);
                                     //     response = await getInsiderAssessmentDescriptionService(selectedAssessment.code, indicators_descriptions);
                                     //        console.log("Response:", response.data.description);
                                     // } catch (err) {
                                     //     setLoading(false);
                                     //     console.error('Error fetching indicator descriptions:', err);
                                     // } finally {
                                     //     setLoading(false);
                                     // }

                                     const buildData = {
                                         user_group: selectedAssessment.code,
                                         image_url: selectedAssessment.icon,
                                         indicator_codes: indicatorObjs.map(i => i.indicator_code),
                                         length_questions: indicatorObjs.reduce((t, i) => t + i.questions, 0),
                                         time_to_complete: indicatorObjs.reduce((t, i) => t + i.duration, 0),
                                         more_info: indicatorObjs.map(i => ({
                                             title: i.title.name,
                                             description: i.title.desc
                                         })),
                                         indicators_descriptions,
                                     };

                                     history.push(
                                         '/dq_pro/products/assessments/name',
                                         {buildData}
                                     )
                                 }}
                             >
                                 Build Assessment
                             </Button>
                     </Box>
                 </Box>
             )}
            </Box>
        </>
    );
};

export default DQProAssessments;
